import { render, staticRenderFns } from "./OrganismTalentFestArticlesGrid.vue?vue&type=template&id=62500856"
import script from "./OrganismTalentFestArticlesGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganismTalentFestArticlesGrid.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports